import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import Loading from "../../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import SelectUsers from "../../../../components/SelectUsers";
import { list as productList, inventoryList } from "../../../../controllers/V1/products/productController";
import { list as pickUpPointList } from "../../../../controllers/V1/cms/pickupPointsDataController";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp, type }) => {
  const handleCancel = () => {
    togglePopUp();
    setUserData({});
    setSelectedProduct("");
    setVariantListData([])
    setSelectedVariant("");
  }

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState({});
  const [productListData, setProductListData] = useState([]);
  const [variantListDate, setVariantListData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedVariant, setSelectedVariant] = useState("");
  const [pickupPointList, setPickupPointList] = useState([]);
  
  const getProductListData = async () => {
    try {
      const options = {
        condition : { status : "A"},
        select : { name : true }
      }
      const res = await productList(options);
      if(res && res?.status === true){
        setProductListData(res?.result || []);
      }
    } catch (error) {
      
    }
  }
  const getPickUpPointList = async () => {
      try {
        const option = {
          condition : { status : "A" },
          limit : 100,
          sort : { name : -1 }
        }
        const res = await pickUpPointList(option);
        if(res?.status === true){
          setPickupPointList(res?.result);
        }
      } catch (error) {
        
      }
    }
  const handleProductChange = (e) => {
    try {
      e.preventDefault();
      const data = JSON.parse(e.target.value);
      setSelectedProduct(data?._id);
      setVariantListData(data?.variants || []);
      if(data?.variants?.length === 1){
        setSelectedVariant(data?.variants[0]?._id)
      }
    } catch (error) {
      
    }
  }
  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission
    setError(null); // Reset the error state before each request
    try {
      let user = {};
      if(userData?.userData){
        user = JSON.parse(userData?.userData);
      }
      setIsLoading(true);
      const option = {
        condition: {
          ...(type === 'Users' && { user_id : userData }),
          ...(type === 'Pick Up Points' && { user_id : userData }),
          // ...(user?._id && { user_id : user?._id }),
          ...(selectedProduct && { product_id : selectedProduct }),
          ...(selectedVariant && { variant_id : selectedVariant }),
          status : "A"
        },
        sort: { user_id : 1, product_id : 1, variant_id : 1},
      };

      // Make the API call
      const res = await inventoryList(option);
      if (res.status === true) {
        let transformData = [];
        if(res?.result?.length > 0){
          transformData = await Promise.all(res?.result.map((items) => {
            return {
              'Name'      : `${items?.user_id?.users_name}${items?.user_id?.last_name}`,
              'Mobile'    : items?.user_id?.users_mobile || "--",
              "POS Number": items?.pos_number || "--",
              "Bind With" : items?.bind_person_name || "--",
              'Product'   : items?.product_id?.name || '--',
              'Unit'      : items?.variant_id?.unit || "--",
              'Total Qty' : items?.qty || "--",
              'Avl. Qty'  : items?.avl_qty || "--",
              'Price'     : items?.variant_id?.price || "--"
            }
          }));
        }
        await exportToExcel(transformData); // Export the results to Excel
        handleCancel(); // Reset the form or close modal
      } else {
        setIsLoading(false);
        setError("No records found matching the criteria.");
      }
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.error("Export Error:", error);
    }
  };

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
      XLSX.writeFile(workbook, `Inventory ${new Date()}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(()=>{
    getProductListData();
    if(type === "Pick Up Points"){
      getPickUpPointList();
    }
  },[type]);

  const handlePickUpChange = async (e) => {
    try {
      const { value } = e.target;
      setUserData(value);
    } catch (error) {
      
    }
  }

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading mt-3">
            Export product inventories
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  {type === "Users" && (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label htmlFor="code" className="all_lable_for_vendor_dashbaord">Retailers/Sales Person :</label>
                      <SelectUsers setAddEditData={setUserData}/>
                    </div>
                  )}

                  {type === "Pick Up Points" && (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label htmlFor="code" className="all_lable_for_vendor_dashbaord" onClick={()=>console.log("userData : ", userData)} >Retailers :</label>
                      <select name="pickUpPoint" id="pickUpPoint" onChange={handlePickUpChange} className="form-control categories_select_tg_enter_product" >
                        <option>Select Pick-Up Points</option>
                        {(pickupPointList && pickupPointList?.length > 0) && (
                          pickupPointList.map((item) => (
                            <option value={item?._id}>{item?.name}</option>
                          ))
                        )}
                      </select>
                    </div>
                  )}

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="product" className="all_lable_for_vendor_dashbaord">Products :</label>
                    <select name="product" id="product" className="form-control categories_select_tg_enter_product" onChange={handleProductChange}>
                      <option>All product</option>
                      {(productListData && productListData?.length > 0) && productListData.map((item)=>(
                        <option value={JSON.stringify(item)} selected={item?._id === selectedProduct}>{item?.name?.toUpperCase()}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="variant" className="all_lable_for_vendor_dashbaord">Variant :</label>
                    <select name="variant" id="variant" className="form-control categories_select_tg_enter_product">
                      <option>All variant</option>
                      {(variantListDate && variantListDate?.length > 0) && variantListDate.map((item)=>(
                        <option value={item?._id} selected={selectedVariant === item?._id} disabled={item?.status !== "A"}>{item?.unit?.toUpperCase()}</option>
                      ))}
                    </select>
                  </div>


                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="submit" className="btn btn-danger" disabled={isLoading}>Download Excel</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
